<form class="input-form" autocomplete="off">
  <div [ngClass]="{'disabledcomponent':disabled}">
    <label *ngIf="outsideLabel !== ''" class="outsidelabel">{{outsideLabel}}</label>
    <mat-form-field class="input-full-width" appearance="outline" (click)="toggleDropdown()">
      <mat-label *ngIf="insideLabel !== ''">{{insideLabel}}</mat-label>
      <div [ngClass]="{'scrollchiplist': scrollChips}">
        <mat-chip-grid #chipGrid tabindex="-1">
          <div [ngClass]="{'scrollchip': scrollChips}">
            @for (chip of displayableChips(); track chip) {
              <mat-chip-row class="primary"
                            tabindex="-1"
                            [removable]="removable"
                            (removed)="removeChip(chip)">
                <span class="primary">{{chip.value | truncate:maxChipTextLength:true}}</span>
                <button matTooltip="{{chip.value}}" matChipRemove>
                  <mat-icon class="primary">cancel</mat-icon>
                </button>
              </mat-chip-row>
            }

            <mat-chip class="primary" *ngIf="moreChips>0"><span class="primary">+{{moreChips}} more</span></mat-chip>
          </div>
        </mat-chip-grid>
        <mat-slider class="slider" *ngIf="scrollChips && chips.length>3" aria-label="unit(s)" [min]="0" [max]="chips.length-3" [step]="1">
          <input matSliderThumb [(ngModel)]="sliderValue" />
        </mat-slider>
        <span [ngClass]="{ 'dropdown-multiselect--active': dropDownOpen }" class="arrow-counts">
          <input [disabled]="disabled" [matChipInputFor]="chipGrid" (keydown)="keyPressed($event)" (keyup)="onTextChange()" placeholder={{placeholder}} [(ngModel)]="text" [ngModelOptions]="{standalone: true}" />
          <span *ngIf="itemsRemaining()>0">+{{itemsRemaining()}}</span><span *ngIf="dropDownSelect" class="dropdown-multiselect__caret"></span>
        </span>
      </div>
    </mat-form-field>
    <mat-error *ngIf="alreadySelected && !dropDownSelect"> Already selected</mat-error>
    <mat-error *ngIf="minimumLengthError && !dropDownSelect"> Minimum Length is {{minimumLength}}</mat-error>
    <div [ngClass]="allowSearchFilter? 'dropdown-withFilter':'dropdown-withoutFilter'" *ngIf="dropDownSelect" class="dropdown-list" [hidden]="!dropDownOpen">
      <ul class="item1">
        <li class="filter-textbox" *ngIf="dropDownData.length>0 && allowSearchFilter">
          <input type="text"
                 placeholder={{searchPlaceholderText}}
                 matInput
                 [(ngModel)]="filterText"
                 [ngModelOptions]="{standalone: true}"
                 (ngModelChange)="onFilterChange()"
                 #filter />
        </li>
        <li *ngIf="allowSelectAll && dropDownData.length > 0" (click)="toggleSelectAll()" class="multiselect-item-checkbox dropdownlistselectall">
          <mat-checkbox type="checkbox" #selectAllCheckbox aria-label="multiselect-select-all" [checked]="isAllItemsSelected()" [disabled]="disabled || !canSelectMore()">{{!isAllItemsSelected() ? selectAllText : unSelectAllText}}</mat-checkbox>
        </li>
      </ul>
      <hr *ngIf="allowSelectAll" />
      <ul class="item2">
        <li class="listitems multiselect-item-checkbox" *ngFor="let item of filteredDropDownData">
          <label [ngClass]="{'disabledcomponent':disabled || (!canSelectMore() && !item.isSelected && !singleSelect) || item.isDisabled}">
            <input class="listitemscheckbox" type="checkbox" (change)="listItemChange(item.key, $event)" [attr.aria-label]="item.value" [checked]="item.isSelected" [disabled]="disabled || (!canSelectMore() && !item.isSelected && !singleSelect) || item.isDisabled" />
            {{item.value}}
          </label>
        </li>
        <li class='no-filtered-data' *ngIf="dropDownData.length !== 0 && filteredDropDownData.length === 0 && !dropDownSelect">
          <h5>{{noFilteredDataAvailableText}}</h5>
        </li>
        <li class='no-data' *ngIf="dropDownData.length === 0 && !dropDownSelect">
          <h5>{{noDataAvailableText}}</h5>
        </li>
      </ul>
    </div>
  </div>
</form>
